import {Box, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography,} from "@mui/material";
import * as React from "react";
import {useEffect} from "react";
import GenericDialog from "../../../components/dialog/generic-dialog.component";
import {translate} from "../../../translate/translate";
import {ErrorComponent} from "../../../components/error/error.component";
import {URLS} from "../../../services/app-urls";
import {toast} from "react-toastify";
import {PoMonitoringService} from "../../../services/po-monitoring-service";
import {AbstractService} from "../../../services/abstract-service";
import {Client} from "../../../models/basic/client";


const AddClientComponent = (props: any) => {
    const {
        openDialog,
        handleCloseDialog,
        isDisabled,
        id,
        client,
    } = props;

    const service = new PoMonitoringService();
    const clientService = new AbstractService<Client>(URLS.CLIENT);

    const [selectedClient, setSelectedClient] = React.useState<number | undefined>(client?.id || undefined);
    const [dataSource, setDataSource] = React.useState<Client[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);

    useEffect(() => {
        setSelectedClient(client?.id);
        openDialog && search(client?.active);
    }, [client, openDialog]);

    const search = (ativo = true) => {
        const filter = ativo ? {active: true} : {};
        clientService.readAll(filter).then(response => {
            const data = !response.data.length ? client ? [client] : [] : response.data;
            setDataSource(data);
            if (!!dataSource && dataSource.length > 0 && !dataSource.find(item => item.id == client?.id)) {
                setSelectedClient(undefined);
            }
        }).catch((error: any) => {
            ErrorComponent(error);
        });
    }

    const handleSubmit = () => {
        const obj = {client: selectedClient};
        setLoading(true);
        service.patch(id, obj).then(response => {
            toast.success(translate.t("successfully_updated"));
            setSelectedClient(undefined);
            handleCloseDialog(true);
        }).catch((error: any) => {
            ErrorComponent(error);
        }).finally(() => {
            setLoading(false);
        });
    };

    return (
		<GenericDialog
			open={openDialog}
			onClose={() => {
				setSelectedClient(undefined);
				handleCloseDialog();
			}}
			title={"add_client"}
			colorButton={"primary"}
			labelButton={"save"}
			disableConfirm={isDisabled || !selectedClient || loading}
			loading={loading}
			handleConfirm={handleSubmit}>
			<Box>
				<Box style={{marginTop: '0.5rem'}}>
					<FormControl>
						<Typography style={{fontWeight: 'bold', marginBottom: "16px"}}>
							{translate.t("select_client_po")}
						</Typography>
						<Grid container spacing={2}>
							{(() => {
								const columnCount = 2;
								const rowsPerColumn = Math.ceil(dataSource.length / columnCount);
								const columns = Array.from({ length: columnCount }, (_, columnIndex) =>
									dataSource.slice(
										columnIndex * rowsPerColumn,
										(columnIndex + 1) * rowsPerColumn
									)
								);
								const maxRows = Math.max(...columns.map((col) => col.length));

								return Array.from({ length: maxRows }, (_, rowIndex) => (
									<>
										{columns.map((column, colIndex) => (
											<Grid key={`${colIndex}-${rowIndex}`} size={6} sx={{paddingTop: "0px !important"}}>
												{column[rowIndex] ? (
													<RadioGroup
														row
														name="client"
														onChange={(event) =>
															setSelectedClient(Number(event.target.value))
														}
													>
													   <FormControlLabel
															checked={selectedClient === column[rowIndex].id}
															control={<Radio />}
															label={column[rowIndex].name}
															value={column[rowIndex].id}
													   />
													</RadioGroup>
												) : null}
											</Grid>
										))}
									</>
								));
							})()}
						</Grid>
					</FormControl>
				</Box>
			</Box>
		</GenericDialog>
    )
}

export default AddClientComponent;
